// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__MooPA","label":"Category_label__dCKF3","content":"Category_content__3EOoR","header":"Category_header__2lcuV","location":"Category_location__2Tm6z"};